import { Controller } from '@hotwired/stimulus'

export default class ButtonGroupController extends Controller<HTMLElement> {
  static values = {
    groupName: String
  }

  connect() {
    this.element.addEventListener('change', event => this.#handleChange(event))
  }

  disconnect() {
    this.element.removeEventListener('change', event => this.#handleChange(event))
  }

  #handleChange() {
    const checkedTarget = Array.from(this.element.querySelectorAll('[type="radio"]:checked')).shift()
    if (checkedTarget) {
      this.dispatch(this.groupNameValue, { detail: checkedTarget.value })
    }
  }
}
